var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center mt-8"},[_c('v-progress-circular',{staticClass:"mt-4",attrs:{"indeterminate":"","color":"smoke","width":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }